import React from 'react';
import { Grid } from 'vindi-ds-components';
import SectionWithGrid from './section_with_grid';
import getField from './field';

function RenderSection({
  title, fields, form, subtitle, values,
}) {
  return (
    <SectionWithGrid title={title} form={form} subtitle={subtitle} values={values}>
      {
        fields.map((item) => (
          <Grid item xs={item.grid.xs} md={item.grid.md} key={item.field.name}>
            {getField(item)}
          </Grid>
        ))
      }
    </SectionWithGrid>
  );
}

export default RenderSection;
